require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-maris-mcedward.json") })
        }
      }, "path---blog-author-maris-mcedward");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-maris-mcedward!./.cache/json/blog-author-maris-mcedward.json
// module id = 673
// module chunks = 231608221292675